module.exports = __webpack_public_path__ + "static/SW1-24bd86280052c48d1a5a05bdbd580108.png";